import {
  Component,
  OnInit,
  AfterViewChecked,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

import { SpecialFormControl } from "@utilities/SpecialForms";
import { ControlFormsService } from '@services/control-forms.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: "control-richtext",
  templateUrl: "./control-richtext.component.html",
  styleUrls: ["./control-richtext.component.scss"],
})
export class ControlRichTextComponent implements OnInit, AfterViewChecked {
  @Input("sfcontrol") _sfcontrol: SpecialFormControl;
  @Output("blurAction") _blurAction: EventEmitter<any> = new EventEmitter();
  @Output("enterKey") _enterKey: EventEmitter<any> = new EventEmitter();

  public froala: string = "";

  public options: Object;
  private _finisher$ = new Subject<void>();

  constructor(
    
    private _controlFormsService: ControlFormsService,
  ) {
  }

  ngOnInit() {
    this._sfcontrol.valueChanges
      .pipe()
      .subscribe((value) => (this.froala = value));
      this.activacion();
      
  }

  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    //this.options = optionsDisabled;
  }

  activacion(): void{
    this._controlFormsService.itemValueRichText.pipe(takeUntil(this._finisher$)).subscribe((nextValue) => {
   
    if (nextValue == false) {
      this.options = {
        attribution: false,
        charCounterCount: false,
        quickInsertEnabled: false,
        placeholderText: false,
        events: {
          initialized: (editor) => {
            _editor: editor.getEditor().edit.off();
          },
        },
        toolbarButtons: {
          // Key represents the more button from the toolbar.
          moreText: {
            // List of buttons used in the  group.
            buttons: [
              "bold",
              "italic",
              "fontFamily",
              "fontSize",
              "textColor",
              "backgroundColor",
              "inlineClass",
              "inlineStyle",
              "underline",
              "strikeThrough",
              "clearFormatting",
            ],

            // Alignment of the group in the toolbar.
            align: "left",

            // By default, 3 buttons are shown in the main toolbar. The rest of them are available when using the more button.
            buttonsVisible: 4,
          },

          moreParagraph: {
            buttons: [
              "alignLeft",
              "alignCenter",
              "alignRight",
              "alignJustify",
              "formatOLSimple",
              "formatOL",
              "formatUL",
              "paragraphFormat",
              "paragraphStyle",
              "lineHeight",
              "outdent",
              "indent",
              "quote",
            ],
            align: "left",
            buttonsVisible: 4,
          },

          moreRich: {
            buttons: [
              "insertLink",
              "insertImage",
              "emoticons",
              "fontAwesome",
              "specialCharacters",
              "embedly",
              "insertFile",
              "insertHR",
              "insertTable",
            ],
            align: "left",
            buttonsVisible: 3,
          },

          moreMisc: {
            buttons: [
              "html",
              "undo",
              "redo",
              "fullscreen",
              "print",
              "selectAll",
              "help",
            ],
            align: "right",
            buttonsVisible: 3,
          },
        },

        // Change buttons for XS screen.
        toolbarButtonsXS: [
          ["undo", "redo"],
          ["bold", "italic", "underline"],
        ],

        theme: "dark",
      };
    } else {
      this.options = {
        attribution: false,
        charCounterCount: false,
        quickInsertEnabled: false,
        placeholderText: false,
        toolbarButtons: {
          // Key represents the more button from the toolbar.
          moreText: {
            // List of buttons used in the  group.
            buttons: [
              "bold",
              "italic",
              "fontFamily",
              "fontSize",
              "textColor",
              "backgroundColor",
              "inlineClass",
              "inlineStyle",
              "underline",
              "strikeThrough",
              "clearFormatting",
            ],

            // Alignment of the group in the toolbar.
            align: "left",

            // By default, 3 buttons are shown in the main toolbar. The rest of them are available when using the more button.
            buttonsVisible: 4,
          },

          moreParagraph: {
            buttons: [
              "alignLeft",
              "alignCenter",
              "alignRight",
              "alignJustify",
              "formatOLSimple",
              "formatOL",
              "formatUL",
              "paragraphFormat",
              "paragraphStyle",
              "lineHeight",
              "outdent",
              "indent",
              "quote",
            ],
            align: "left",
            buttonsVisible: 4,
          },

          moreRich: {
            buttons: [
              "insertLink",
              "insertImage",
              "emoticons",
              "fontAwesome",
              "specialCharacters",
              "embedly",
              "insertFile",
              "insertHR",
              "insertTable",
            ],
            align: "left",
            buttonsVisible: 3,
          },

          moreMisc: {
            buttons: [
              "html",
              "undo",
              "redo",
              "fullscreen",
              "print",
              "selectAll",
              "help",
            ],
            align: "right",
            buttonsVisible: 3,
          },
        },

        // Change buttons for XS screen.
        toolbarButtonsXS: [
          ["undo", "redo"],
          ["bold", "italic", "underline"],
        ],

        theme: "dark",
      };
    }

  });
  }

  ngOnDestroy(): void {
    this._finisher$.next();
  }
}
